import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';
import Button from '../Button';
import { withStyles } from '@material-ui/core/styles';
import { CardActions } from '@material-ui/core';
import PlanCard from '../plans/PlanCard';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { isValid } from '../../helpers/subscription';
import Typography from '@material-ui/core/Typography';
import TrialPeriodImage from '../../images/one_month_free_trial_visual.png'
import ConfirmButton from '../ConfirmButton';

/**
 * Subscription creation view for one product,
 * displays a plan picker with "purchase" and "start trial" buttons
 * "purchase" form allows to select a number of licences
 */

const styles = theme => ({
  spacing: {
    marginLeft: 40,
  },
  actions: {
    justifyContent: 'center',
  },
  purchaseButton: {
    marginBottom: 8,
    marginRight: 24,
  },
  cancelButton: {
    marginBottom: 8,
    marginRight: 16,
    color: 'rgba(0,0,0,0.54)'
  },
  customButton: {
    marginTop: 8,
    marginBottom: 16,
    marginLeft:56,
    marginRight: 56,
    borderRadius: 24,
    backgroundColor: '#3E82F7',
    boxShadow: 'none'
  },
  imageContent: {
    height:90
  },
  image: {
    height: 85,
    justifyContent: 'center',
    //maxWidth: 250,
  },
  plansSectionLabel: {
    position: 'relative',
    top: 56,
    left: 48
  }
})

/**
 * Plan view of the plan picker
 * displays "start trial" and "purchase" which opens a form to select number of licences
 */
class CreateSubscriptionPlan extends Component {

  render() {

    const {
      product,
      plan, licencesCount,
      disabled,
      handlePurchase,
      handleSubscribe,
      classes,
      isCreatingSubscription,
    } = this.props;

    const working = product.subscribing && product.subscribing.planId === plan.id;

    return (
      <PlanCard
        plan={plan}
        isCreatingSubscription={isCreatingSubscription}
        actions={
          !plan.isFree ?
            <CardActions className={classes.actions}>
              <ConfirmButton
                    className={classes.customButton}
                    variant="contained"
                    size="medium" 
                    fullWidth
                    color="primary"
                    title={
                      <FormattedMessage 
                        id="plan.greeting.title" 
                        values={{productName: product.name, planName: plan.name}}/>
                    }
                    message={<FormattedMessage id="plan.greeting.content" /> }
                    no={<FormattedMessage id="plan.greeting.no.button" />}
                    yes={<FormattedMessage id="plan.greeting.yes.button" />}
                    onClick={() => handlePurchase({ plan, licencesCount })}
                    proceed={() => handleSubscribe({ plan, licencesCount })}
                    disabled={!isValid(plan, licencesCount) || isCreatingSubscription}
                    working={working}
                  >  
                    <FormattedMessage id='plan.button.tryIt' /> 
              </ConfirmButton> 
            </CardActions>
          /*<div>
            <Collapse in={open} className={classes.form}>
              <Divider />
              <CardContent>
                <SubscriptionForm
                  plan={plan}
                  targetPlan={plan}
                  licencesCount={licencesCount}
                  handleLicencesCount={handleLicencesCount}
                />
              </CardContent>
              <CardActions>
                <Button
                  className={classes.cancelButton}
                  size="medium"
                  onClick={() => handleSelect(null)}
                > 
                  <FormattedMessage id='plan.button.cancel' />
                </Button>
                <Button
                  className={classes.purchaseButton}
                  size="medium"
                  color="primary"
                  working={working}
                  disabled={!isValid(plan, licencesCount) || isCreatingSubscription}
                  onClick={() => handlePurchase({ plan, licencesCount })}
                >
                  <FormattedMessage id='plan.button.purchase' />
              </Button>
              </CardActions>
            </Collapse>
            <Collapse in={!open}>
              <CardActions className={classes.actions}>
                <Button
                  className={classes.customButton}
                  variant="contained"
                  size="medium"
                  fullWidth
                  disabled={disabled || isCreatingSubscription}
                  onClick={() => handleSelect(plan)}
                >
                  <FormattedMessage id='plan.button.purchase' />             
              </Button>
              </CardActions>
            </Collapse>
          </div>*/
          :
          <div>
            <CardActions className={classes.actions}>
              <Button
                className={classes.customButton}
                size="medium"
                variant="contained"
                fullWidth
                working={working}
                disabled={!isValid(plan, licencesCount) || disabled || isCreatingSubscription}
                onClick={() => handleSubscribe({ plan, licencesCount : 1 })}
              >
                <FormattedMessage id='plan.button.subscribe' />
              </Button>
          </CardActions>
          </div>
        }
      />
    )
  }
}

/** 
 * Product plan picker
 * Holds current licences count and currently selected plan
*/
class CreateSubscription extends Component {

  constructor(props) {
    super(props);
    this.state = {
      plan: null,
      licencesCount: 1
    }
  }

  /**
   * Called when the number of licences changes
   * @param {Integer} licencesCount 
   */
  handleLicencesCount(licencesCount) {
    this.setState({ licencesCount });
  }

  /**
   * Called when a plan is selected 
   * (ie the user clicked on "purchase" and the form open)
   * @param {Object} plan 
   */
  handlePlan(plan) {
    const { licencesCount } = this.state;

    // if a plan is selected and current licencesCount is fewer than plan's licencesCount
    if (plan && licencesCount < plan.licencesCount) {
      this.setState({
        licencesCount: plan.licencesCount
      });
    }

    this.setState({ plan });

  }

  /**
   * Returns true if the plan passed as parameter is currently selected
   * @param {Object} plan Plan to test
   */
  isSelected(plan) {
    const currentPlan = this.state.plan;
    return currentPlan && currentPlan.id === plan.id;
  }

  render() {
    const {
      account,
      product,
      handleSubscribe,
      handlePurchase,
      classes,
      intl,
      disabled,
      isCreatingSubscription,
      planTargetPeriodicity,
      isBothPeriodicityAvailable
    } = this.props;

    let prefilteredPlans = [];
    if (isBothPeriodicityAvailable) {
      prefilteredPlans =  product.plans.filter(plan => plan.isFree || plan.periodicity === planTargetPeriodicity);
    } else {
      prefilteredPlans = product.plans;
    }
    
    return (
      <div>
        <div style={{display:'flex', flexDirection:'row', marginTop:16, marginBottom:16}}>
          <Typography variant="h5" align='left' className={classes.plansSectionLabel} >
            {product.plans.length > 1 ?
              <FormattedMessage id='product.plan.title.plural' />
              :
              <FormattedMessage id='product.plan.title' />
            }
          </Typography> 
        </div>
        <Grid container justify='center' spacing={16}>
          {prefilteredPlans
            .map(plan => (
              <Grid key={plan.id} item lg={3} md={4} sm={12}  >
                <div style={{display:'flex', flexDirection:'column', alignItems:'flex-end'}}>
                  {!plan.isFree ?
                    <div className={classes.imageContent}>
                      <img className={classes.image} src={TrialPeriodImage} alt="One month free trial visual" />
                    </div>
                    :
                    <div className={classes.imageContent} ></div>
                  }
                </div>
                <CreateSubscriptionPlan
                  intl={intl} // FIXME: wrap other component ?
                  product={product}
                  plan={plan}
                  allowTrial={!disabled && plan.trialDuration}
                  disabled={disabled}
                  licencesCount={plan.licencesCount}
                  open={this.isSelected(plan)}
                  handleSubscribe={sub => handleSubscribe({ ...sub, account, product })}
                  handlePurchase={sub => handlePurchase({ ...sub, account, product })}
                  handleLicencesCount={licencesCount => this.handleLicencesCount(licencesCount)}
                  handleSelect={plan => this.handlePlan(plan)}
                  classes={classes}
                  isCreatingSubscription={isCreatingSubscription}
                  
                />
              </Grid>
            ))
            
          }
        </Grid>
      </div>
    )
  }
}

CreateSubscription.propTypes = {
  intl: intlShape.isRequired,
  product: PropTypes.object.isRequired,
  subscription: PropTypes.object,
  handleSubscribe: PropTypes.func.isRequired,
  handlePurchase: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isCreatingSubscription: PropTypes.bool,
}

export default withStyles(styles)(
  injectIntl(CreateSubscription)
);


// WEBPACK FOOTER //
// ./src/components/products/CreateSubscription.js